import { usePostChannelOwnershipVerify } from '@/api/channel'
import pagePath from '@/utils/pagePath'
import styled from '@emotion/styled'
import { Button, Flex, LabelForm, Title, useToastPopup } from '@collable/ui'
import { useState } from 'react'
import { useNavigate } from 'react-router'

interface VerifyEmailCodeProps {
  ownershipRequestId: number
}

const VerifyEmailCode = ({ ownershipRequestId }: VerifyEmailCodeProps) => {
  const [otp, setOtp] = useState('')
  const { mutate: postChannelOwnershipVerify } = usePostChannelOwnershipVerify()
  const navigate = useNavigate()
  const { addToastPopup } = useToastPopup()

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    postChannelOwnershipVerify(
      { ownershipRequestId, otp },
      {
        onSuccess: () => {
          addToastPopup({
            type: 'normal',
            message: '승인 요청 완료',
            status: 'positive',
          })
          navigate(pagePath.channelVideos('temp-email'))
        },
      },
    )
  }

  return (
    <Content direction="column" gap={40} as="form" onSubmit={onSubmit}>
      <Title size="title2" fontWeight="bold" color="labelStrong" as="h2">
        이메일로 인증번호 <br />
        6자리를 발송했어요
      </Title>
      <LabelForm
        type="text"
        required
        label="이메일 인증번호"
        placeholder="6자리 입력"
        size="large"
        value={otp}
        width="100%"
        onChange={e => setOtp(e.target.value)}
        maxLength={6}
      />
      <Button
        width="100"
        color="primary"
        kind="solid"
        size="large"
        disabled={otp.length !== 6}
        type="submit"
      >
        인증하기
      </Button>
    </Content>
  )
}

export default VerifyEmailCode

const Content = styled(Flex)`
  width: 600px;
  border-radius: 20px;
  padding: 28px;
  background-color: ${({ theme }) => theme.common.commonWhite};
`
